export const updatePodcastUrl = (podcastId) => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set('podId', podcastId);
  window.history.replaceState(null, '', `?${searchParams.toString()}`);
};

export const getPodcastIdFromUrl = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('podId');
};

export const isSpotifyId = (podcastId) => {
  return podcastId && /^[a-zA-Z0-9]+$/.test(podcastId) && !/^\d+$/.test(podcastId);
};
